export const GET_CHANNEL_DATA = "GET_CHANNEL_DATA";
export const GET_CHANNEL_DATA_SUCCESS = "GET_CHANNEL_DATA_SUCCESS";
export const GET_CHANNEL_DATA_FAIL = "GET_CHANNEL_DATA_FAIL";
export const UPDATE_CHANNEL_DATA_STATE = "UPDATE_cHANNEL_DATA_STATE";
export const CLEAR_UPDATE_CHANNEL_DATA_STATE = "CLEAR_UPDATE_CHANNEL_DATA_STATE";

export const CHANGE_CHANNEL_DATA = "CHANGE_CHANNEL_DATA";